import { render, staticRenderFns } from "./LongText.vue?vue&type=template&id=7bcfc918"
import script from "./LongText.vue?vue&type=script&lang=js"
export * from "./LongText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports